export const UpdateDisplayFirmwareVersion = 'Device.UpdateDisplayFirmwareVersion';
export interface UpdateDisplayFirmwareVersion {
	type: typeof UpdateDisplayFirmwareVersion;
	version: string;
}
